export const locale = {
    GRN_FORMAT: {
        HEADER: {
            DATE: "วันที่",
            SUPPLIER: "ชื่อร้านค้า",
            SUPPLIER_CODE: "รหัสซัพพลายเออร์",
            REMARK: "",
            MOBILE: "เบอร์โทรติดต่อ",
            CONTACT_PERSON: "ชื่อผู้ติดต่อ",
            DOC_NO: "เลขที่ใบรับสินค้า",
            PHONE_NO: "เบอร์โทรติดต่อ",
            PAYMENT_METHOD: "วิธีการชำระเงิน",
            RECEIPT: "ใบเสร็จ",
            SHARED_SO: "แบ่งปันดังนั้น",
            COURIER_COMPANY: "บริษัทจัดส่ง",
            CONSIGNMENT_NO: "หมายเลขฝากขาย",
            AC_NO: "เลขที่บัญชี",
            AC_NAME: "ชื่อบัญชี",
            DUE_DATES: "วันครบกำหนด",
            BANK_NAME: "ชื่อธนาคาร",
            BRANCH: "สาขา",
            NOTICE_ID: ""
        },
        CONTENT: {
            SERIAL_NO: "อันดับที่",
            CUSTOMER_MARKING: "รหัสลูกค้า",
            SO_NO: "เลขที่บิล",
            CTN: "จำนาวนกระสอบ",
            WEIGHT: "น้ำหนัก",
            CURRENCY: "สกุลเงิน",
            DIMENSION: "",
            OTHER: "",
            PN: "PN",
            TOTAL: "ยอดรวม",
            CONSIGNMENT_NO: "หมายเลขผู้จัดส่ง",
            TOTAL_AMT: "ยอดรวม",
            DISC: "ส่วนลด",
            DEPOSIT: "ค่ามัดจำ",
            OTH_CHARGES: "ค่าใช้จ่ายอื่นๆ",
            BAL_AMT: "ยอดรวมทั้งหมด"
        },
        FOOTER: {
            DELIVER: "ลายเซ็นต์ผู้ส่ง",
            PERSON_IN_CHARGES: "ลายเซ็นต์ผู้รับ",
            CONTACT_PERSON: "ติดต่อ",
            CONTACT_NO: "เบอร์โทรติดต่อ",
        },

    }
}